import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import GridCard from '../components/GridCard'
import GeneralDocs from '../components/GeneralDocs'
import GeneralInfo from '../components/GeneralInfo'
import SelectionBar from '../components/selection/SelectionBar'
import { config } from '../settings/configs'
import {
  useGetDesignazioniStatsQuery,
  useGetRimborsiStatsQuery,
} from '../hooks/api-slice'

const DashboardArbitro = () => {
  const { idArbitro } = useSelector(state => state.home.infoUtente)
  const selectedStagione = useSelector(
    state => state.selection.selectedStagione,
  )

  document.title = `${config?.name} - Home`

  const { data: designazioniStats } = useGetDesignazioniStatsQuery(
    { stagione: `/stagione/${selectedStagione}`, idArbitro },
    { skip: !(idArbitro && selectedStagione) },
  )

  const { data: rimborsiStats } = useGetRimborsiStatsQuery(
    { stagione: selectedStagione, idArbitro },
    { skip: !(idArbitro && selectedStagione) },
  )

  return (
    <Grid
      container
      paddingX={2}
      marginY={2}
      rowSpacing={3}
      columnSpacing={2}
      alignItems='stretch'
      sx={{ width: '100%' }}
    >
      <GeneralInfo />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar yStagione />
      </Grid>
      {config?.features?.designazioni && (
        <GridCard
          title='Designazioni'
          subtitle1={`${designazioniStats?.accepted || 0} ${
            designazioniStats?.accepted === 1 ? 'accettata' : 'accettate'
          }`}
          subtitle2={`${designazioniStats?.waiting || 0} ${
            designazioniStats?.waiting === 1 ? 'da confermare' : 'da confermare'
          }`}
          linkTo='/designazioni'
          isError={designazioniStats?.waiting > 0}
        />
      )}
      {config?.features?.rimborsi && (
        <GridCard
          title='Rimborsi'
          subtitle1={`${rimborsiStats?.pagati || 0} ${
            rimborsiStats?.pagati === 1 ? 'ricevuto' : 'ricevuti'
          }`}
          subtitle2={`${rimborsiStats?.nonPagati || 0} ${
            rimborsiStats?.nonPagati === 1 ? 'da ricevere' : 'da ricevere'
          }`}
          linkTo='/rimborsi'
          isError={rimborsiStats?.nonPagati > 0}
        />
      )}
      <GeneralDocs />
    </Grid>
  )
}

export default DashboardArbitro
